import { useState, useEffect } from 'react';
import { Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import linkIcon from '../../img/Link.svg';
import { copyUrlToClipboard } from '@client/utils/share';

const ShareButton = ({ className, resetKey, onShare }) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (isCopied) setIsCopied(false);
  }, [resetKey]);

  const handleClick = async () => {
    if (onShare) {
      const success = await onShare();
      if (success) setIsCopied(true);
    } else {
      const success = await copyUrlToClipboard();
      if (success) setIsCopied(true);
    }
  };

  return (
    <Button
      type="primary"
      size="large"
      onClick={handleClick}
      className={className}
    >
      {isCopied ? (
        <CheckOutlined />
      ) : (
        <img src={linkIcon} alt="" className="w-4 h-4" />
      )}
      {isCopied ? t('common|Link copied') : t('common|Share results')}
    </Button>
  );
};

export default ShareButton;
